@import '../../styles/host.css';

:host {
    display: block;
    margin: var(--protean-checkbox-margin, 1rem);
}

:host([disabled]) label {
    cursor: not-allowed;
    opacity: var(--protean-checkbox-disabled-opacity, 0.4);
}

label {
    display: flex;
    align-items: center;
    cursor: pointer;
    min-height: 24px;
}

:host([alignment='right']) label {
    flex-direction: row-reverse;
    justify-content: flex-end;
}

.checkbox-symbol {
    flex: 0 0 24px;
    margin-right: 0.625rem;
    stroke-linecap: round;
    stroke-linejoin: round;
}

:host([alignment='right']) .checkbox-symbol {
    margin-left: 0.625rem;
    margin-right: 0;
}

input:focus + label .checkbox-symbol {
    outline: auto;
}

.checkbox-outline {
    fill: transparent;
    stroke: var(--protean-checkbox-outline-color, #c7b5fb);
    stroke-width: 3;
    transition:
        fill 0.2s ease-in-out,
        stroke 0.2s ease-in-out;
}

:host([checked]) .checkbox-outline,
:host([indeterminate]) .checkbox-outline {
    --protean-checkbox-outline-color: var(
        --protean-checkbox-checked-outer-color,
        #c7b5fb
    );
    fill: var(--protean-checkbox-checked-outer-color, #c7b5fb);
}

.checkbox-fill {
    stroke: var(--protean-checkbox-checked-inner-color, #000000);
    fill: none;
    stroke-width: 3;
}

:host([variant='toggle']) .checkbox-symbol {
    flex-basis: 45px;
    border-radius: 10px;
}

.toggle-path {
    stroke: var(--protean-checkbox-toggle-path-color, #535353);
    stroke-width: 20;
    fill: none;
    transition: stroke 0.2s ease-in-out;
}

:host([checked]) .toggle-path {
    stroke: var(--protean-checkbox-checked-outer-color, #c7b5fb);
}

.toggle-fill {
    fill: var(--protean-checkbox-toggle-circle-fill, #000000);
    stroke: none;
    transition: transform 0.2s ease-in-out;
}

:host([checked]) .toggle-fill {
    transform: translateX(25px);
    fill: var(--protean-checkbox-checked-inner-color, #000000);
}

.label-text {
    flex: 1 0;
}
